import { CommonInput, CommonLabel, FlexBox, INPUT_TYPES, repeat, useBreakpoint, useIsMobile } from "@brg/ui";
import { ActionsButton, DefaultButton, GridMobileNamed, MobileButtonsWrapper, TBody, TeamsMobGridList } from "../styles";
import { LayoutConst } from "core/modules/layout.module";
import { Lang } from "@brg/api";
import { useTranslation } from "react-i18next";
import { ProjectEditPageGridInput } from "_deziiign/books/pages/BookEdit/styles";
import { SpecialDropdownButtons } from "./SpecialDropdownButtons";
import setTextByLang from "shared/helpers/setTextByLang";
import { ReactComponent as PlusSvg } from "../../projectEdit/close.svg";
import { JustTable, RequiredLabel, RequiredSpan } from "_competition/components/style";
import { InfoIcon } from "shared/components/InfoIcon/InfoIcon";
import { useMemo } from "react";

const ButtonEditGroup = ({
    buttons,
    currentLang,
    buttonTypes,
    onChange,
    OnDelete,
    OnAdd,
    forms,
    anchorTypes,
    createButtonText,
}: {
    buttons: any[];
    currentLang: string;
    buttonTypes: any;
    onChange: any;
    OnDelete: any;
    OnAdd: any;
    forms: any;
    anchorTypes?: any;
    createButtonText?: string;
}) => {
    const isS = useBreakpoint(LayoutConst.screen.s - 1);
    const { t } = useTranslation();

    const isMobile = useIsMobile();

    const hasAnchors = useMemo(() => (!!anchorTypes?.length), [anchorTypes])

    return (
        <>
            {!buttons?.length && (
                <FlexBox direction={'row'} directionMobile="row" style={{ marginBottom: !buttons?.length ? 0 : 24 }}>
                    <DefaultButton wh={195} whMob={195} onClick={() => OnAdd()}>
                        <PlusSvg />
                        {createButtonText || t('teams.adminPage.buttons.create')}
                    </DefaultButton>
                </FlexBox>
            )}
            {(!!buttons?.length) && (
                <>
                    {isMobile ? (
                        <>
                            {buttons.map((button, index) => {
                                return (
                                    <MobileButtonsWrapper directionMobile="row" gxMobile={24} offsetTopMobile={24} >
                                        {isS && (
                                            <GridMobileNamed>
                                                <span>{`Кнопка ${index + 1}`}</span>
                                                {button.isRequired ? (
                                                    <FlexBox justify={'flex-start'} width={'100px'}>
                                                    </FlexBox>
                                                ) : (
                                                    <DefaultButton wh={131} whMob={107} onClick={() => OnDelete(index)} isTablet>Удалить</DefaultButton>
                                                )}
                                            </GridMobileNamed>
                                        )}
                                        <TeamsMobGridList isTeamEditButtons cols={repeat(2, isMobile ? '260px' : '306.5px')} >
                                            <CommonInput
                                                type={INPUT_TYPES.dropdown}
                                                orientation="column"
                                                label={t('teams.adminPage.additionalFields.td_style')}
                                                value={{ label: button.type, value: button.type }}
                                                onChange={(value: any) => onChange({ ...button, type: value.value }, index)}
                                                options={buttonTypes}
                                            />
                                            <CommonInput
                                                type={INPUT_TYPES.text}
                                                orientation="column"
                                                label={t('teams.adminPage.additionalFields.td_text')}
                                                value={Lang(button.text, currentLang)}
                                                onChange={(value: any) => onChange({ ...button, text: setTextByLang(button.text, currentLang, value.target.value) }, index)}
                                            />
                                            <CommonInput
                                                type={INPUT_TYPES.text}
                                                orientation="column"
                                                label={t('teams.adminPage.additionalFields.td_text_mobile')}
                                                value={Lang(button.textMobile, currentLang)}
                                                onChange={(value: any) => onChange({ ...button, textMobile: setTextByLang(button.textMobile, currentLang, value.target.value) }, index)}
                                            />

                                            <FlexBox directionMobile="column">
                                                <CommonLabel
                                                    label={t('teams.adminPage.additionalFields.td_href')}
                                                    fixedHeight
                                                    onWhiteBG
                                                />
                                                <ProjectEditPageGridInput isTeamEdit isColumns>
                                                    {button.type?.includes('anchor') ? (
                                                        <CommonInput
                                                            type={INPUT_TYPES.dropdown}
                                                            orientation="column"
                                                            value={{ label: button.type, value: button.type }}
                                                            onChange={(value: any) => onChange({ ...button, type: value.value }, index)}
                                                            options={buttonTypes}
                                                        />
                                                    ) : (
                                                        <>
                                                            {!!button?.isRequired ? (
                                                                <ActionsButton>{t(`teams.adminPage.additionalFields.button_${button.actionType}`)}</ActionsButton>
                                                            ) : (
                                                                <SpecialDropdownButtons
                                                                    currentLang={currentLang}
                                                                    button={button}
                                                                    index={index}
                                                                    onChange={onChange}
                                                                    actualForms={forms}
                                                                />
                                                            )}
                                                        </>
                                                    )}

                                                </ProjectEditPageGridInput>
                                            </FlexBox>
                                        </TeamsMobGridList>
                                        {!isS && (
                                            <>
                                                {!!button?.isRequired ? (
                                                    <FlexBox justify={'flex-start'} style={{ height: '88px' }}>
                                                    </FlexBox>
                                                ) : (
                                                    <DefaultButton style={{ marginTop: isMobile ? '26px' : 0 }} wh={131} whMob={107} onClick={() => OnDelete(index)}>{t('teams.adminPage.buttons.delete')}</DefaultButton>
                                                )}

                                            </>
                                        )}
                                    </MobileButtonsWrapper>
                                )
                            })}
                        </>
                    ) : (
                        <JustTable isTeamEdit>
                            <thead>
                                <tr>
                                    <RequiredLabel style={{ width: '20%' }} className={'required-label'}>{t('teams.adminPage.additionalFields.td_style')}</RequiredLabel>
                                    <RequiredLabel style={{ width: '25%' }} className={'required-label'}>{t('teams.adminPage.additionalFields.td_text')}</RequiredLabel>
                                    <th style={{ width: '25%' }}>{t('teams.adminPage.additionalFields.td_text_mob')}</th>
                                    <th style={{ width: '25%' }}>
                                        <FlexBox align="center" gx={4}>
                                            <RequiredSpan className={'required-label'}>{t('teams.adminPage.additionalFields.td_href')}</RequiredSpan>
                                            <InfoIcon stc msg={t('teams.adminPage.additionalFields.team_context_link')} />
                                        </FlexBox>
                                    </th>
                                </tr>
                            </thead>
                            <TBody>
                                {buttons.map((button, index) => {
                                    return (
                                        <tr>
                                            <td style={{ width: '195px' }}>
                                                <CommonInput
                                                    type={INPUT_TYPES.dropdown}
                                                    value={{ label: t(`teams.adminPage.additionalFields.${button.type}`), value: button.type }}
                                                    onChange={(value: any) => onChange({ ...button, type: value.value }, index)}
                                                    options={buttonTypes.map((option: any) => ({
                                                        label: t(`teams.adminPage.additionalFields.${option.label}`),
                                                        value: option.value
                                                    }))}
                                                />
                                            </td>
                                            <td style={{ width: '180px' }}>
                                                <CommonInput
                                                    type={INPUT_TYPES.text}
                                                    value={Lang(button.text, currentLang)}
                                                    onChange={(value: any) => onChange({ ...button, text: setTextByLang(button.text, currentLang, value.target.value) }, index)}
                                                />
                                            </td>
                                            <td>
                                                <CommonInput
                                                    type={INPUT_TYPES.text}
                                                    value={Lang(button.textMobile, currentLang)}
                                                    onChange={(value: any) => onChange({ ...button, textMobile: setTextByLang(button.textMobile, currentLang, value.target.value) }, index)}
                                                />
                                            </td>
                                            <>
                                                <td>
                                                    {button.type?.includes('anchor') ? (
                                                        <>
                                                            {hasAnchors ? (
                                                                <CommonInput
                                                                    type={INPUT_TYPES.dropdown}
                                                                    value={button.anchor}
                                                                    onChange={(value: any) => onChange({ ...button, anchor: value }, index)}
                                                                    options={anchorTypes}
                                                                />
                                                            ) : (
                                                                <ActionsButton>{t('teams.adminPage.additionalFields.anchor_not_exist')}</ActionsButton>
                                                            )}
                                                        </>
                                                    ) : (
                                                        <>
                                                            {!!button?.isRequired ? (
                                                                <ActionsButton>{t(`teams.adminPage.additionalFields.button_${button.actionType}`)}</ActionsButton>
                                                            ) : (
                                                                <SpecialDropdownButtons
                                                                    currentLang={currentLang}
                                                                    button={button}
                                                                    index={index}
                                                                    onChange={onChange}
                                                                    actualForms={forms}
                                                                />
                                                            )}
                                                        </>
                                                    )}
                                                </td>

                                                <td>
                                                    {!!button?.isRequired ? (
                                                        <FlexBox justify={'flex-start'}>

                                                        </FlexBox>
                                                    ) : (
                                                        <DefaultButton wh={131} whMob={107} onClick={() => OnDelete(index)}>{t('teams.adminPage.buttons.delete')}</DefaultButton>
                                                    )}
                                                </td>
                                            </>
                                        </tr>
                                    );
                                })}
                            </TBody>
                        </JustTable>
                    )}
                </>
            )}
        </>
    )
}

export default ButtonEditGroup;import { CommonInput, CommonLabel, FlexBox, INPUT_TYPES, repeat, useBreakpoint, useIsMobile } from "@brg/ui";
import { ActionsButton, DefaultButton, GridMobileNamed, MobileButtonsWrapper, TBody, TeamsMobGridList } from "../styles";
import { LayoutConst } from "core/modules/layout.module";
import { Lang } from "@brg/api";
import { useTranslation } from "react-i18next";
import { ProjectEditPageGridInput } from "_deziiign/books/pages/BookEdit/styles";
import { SpecialDropdownButtons } from "./SpecialDropdownButtons";
import setTextByLang from "shared/helpers/setTextByLang";
import { ReactComponent as PlusSvg } from "../../projectEdit/close.svg";
import { JustTable, RequiredLabel, RequiredSpan } from "_competition/components/style";
import { InfoIcon } from "shared/components/InfoIcon/InfoIcon";
import { useMemo } from "react";

const ButtonEditGroup = ({
    buttons,
    currentLang,
    buttonTypes,
    onChange,
    OnDelete,
    OnAdd,
    forms,
    anchorTypes,
    createButtonText,
}: {
    buttons: any[];
    currentLang: string;
    buttonTypes: any;
    onChange: any;
    OnDelete: any;
    OnAdd: any;
    forms: any;
    anchorTypes?: any;
    createButtonText?: string;
}) => {
    const isS = useBreakpoint(LayoutConst.screen.s - 1);
    const { t } = useTranslation();

    const isMobile = useIsMobile();

    const hasAnchors = useMemo(() => (!!anchorTypes?.length), [anchorTypes])

    return (
        <>
            {!buttons?.length && (
                <FlexBox direction={'row'} directionMobile="row" style={{ marginBottom: !buttons?.length ? 0 : 24 }}>
                    <DefaultButton wh={195} whMob={195} onClick={() => OnAdd()}>
                        <PlusSvg />
                        {createButtonText || t('teams.adminPage.buttons.create')}
                    </DefaultButton>
                </FlexBox>
            )}
            {(!!buttons?.length) && (
                <>
                    {isMobile ? (
                        <>
                            {buttons.map((button, index) => {
                                return (
                                    <MobileButtonsWrapper directionMobile="row" gxMobile={24} offsetTopMobile={24} >
                                        {isS && (
                                            <GridMobileNamed>
                                                <span>{`Кнопка ${index + 1}`}</span>
                                                {button.isRequired ? (
                                                    <FlexBox justify={'flex-start'} width={'100px'}>
                                                    </FlexBox>
                                                ) : (
                                                    <DefaultButton wh={131} whMob={107} onClick={() => OnDelete(index)} isTablet>Удалить</DefaultButton>
                                                )}
                                            </GridMobileNamed>
                                        )}
                                        <TeamsMobGridList isTeamEditButtons cols={repeat(2, isMobile ? '260px' : '306.5px')} >
                                            <CommonInput
                                                type={INPUT_TYPES.dropdown}
                                                orientation="column"
                                                label={t('teams.adminPage.additionalFields.td_style')}
                                                value={{ label: button.type, value: button.type }}
                                                onChange={(value: any) => onChange({ ...button, type: value.value }, index)}
                                                options={buttonTypes}
                                            />
                                            <CommonInput
                                                type={INPUT_TYPES.text}
                                                orientation="column"
                                                label={t('teams.adminPage.additionalFields.td_text')}
                                                value={Lang(button.text, currentLang)}
                                                onChange={(value: any) => onChange({ ...button, text: setTextByLang(button.text, currentLang, value.target.value) }, index)}
                                            />
                                            <CommonInput
                                                type={INPUT_TYPES.text}
                                                orientation="column"
                                                label={t('teams.adminPage.additionalFields.td_text_mobile')}
                                                value={Lang(button.textMobile, currentLang)}
                                                onChange={(value: any) => onChange({ ...button, textMobile: setTextByLang(button.textMobile, currentLang, value.target.value) }, index)}
                                            />

                                            <FlexBox directionMobile="column">
                                                <CommonLabel
                                                    label={t('teams.adminPage.additionalFields.td_href')}
                                                    fixedHeight
                                                    onWhiteBG
                                                />
                                                <ProjectEditPageGridInput isTeamEdit isColumns>
                                                    {button.type?.includes('anchor') ? (
                                                        <CommonInput
                                                            type={INPUT_TYPES.dropdown}
                                                            orientation="column"
                                                            value={{ label: button.type, value: button.type }}
                                                            onChange={(value: any) => onChange({ ...button, type: value.value }, index)}
                                                            options={buttonTypes}
                                                        />
                                                    ) : (
                                                        <>
                                                            {!!button?.isRequired ? (
                                                                <ActionsButton>{t(`teams.adminPage.additionalFields.button_${button.actionType}`)}</ActionsButton>
                                                            ) : (
                                                                <SpecialDropdownButtons
                                                                    currentLang={currentLang}
                                                                    button={button}
                                                                    index={index}
                                                                    onChange={onChange}
                                                                    actualForms={forms}
                                                                />
                                                            )}
                                                        </>
                                                    )}

                                                </ProjectEditPageGridInput>
                                            </FlexBox>
                                        </TeamsMobGridList>
                                        {!isS && (
                                            <>
                                                {!!button?.isRequired ? (
                                                    <FlexBox justify={'flex-start'} style={{ height: '88px' }}>
                                                    </FlexBox>
                                                ) : (
                                                    <DefaultButton style={{ marginTop: isMobile ? '26px' : 0 }} wh={131} whMob={107} onClick={() => OnDelete(index)}>{t('teams.adminPage.buttons.delete')}</DefaultButton>
                                                )}

                                            </>
                                        )}
                                    </MobileButtonsWrapper>
                                )
                            })}
                        </>
                    ) : (
                        <JustTable isTeamEdit>
                            <thead>
                                <tr>
                                    <RequiredLabel style={{ width: '20%' }} className={'required-label'}>{t('teams.adminPage.additionalFields.td_style')}</RequiredLabel>
                                    <RequiredLabel style={{ width: '25%' }} className={'required-label'}>{t('teams.adminPage.additionalFields.td_text')}</RequiredLabel>
                                    <th style={{ width: '25%' }}>{t('teams.adminPage.additionalFields.td_text_mob')}</th>
                                    <th style={{ width: '25%' }}>
                                        <FlexBox align="center" gx={4}>
                                            <RequiredSpan className={'required-label'}>{t('teams.adminPage.additionalFields.td_href')}</RequiredSpan>
                                            <InfoIcon stc msg={t('teams.adminPage.additionalFields.team_context_link')} />
                                        </FlexBox>
                                    </th>
                                </tr>
                            </thead>
                            <TBody>
                                {buttons.map((button, index) => {
                                    return (
                                        <tr>
                                            <td style={{ width: '195px' }}>
                                                <CommonInput
                                                    type={INPUT_TYPES.dropdown}
                                                    value={{ label: t(`teams.adminPage.additionalFields.${button.type}`), value: button.type }}
                                                    onChange={(value: any) => onChange({ ...button, type: value.value }, index)}
                                                    options={buttonTypes.map((option: any) => ({
                                                        label: t(`teams.adminPage.additionalFields.${option.label}`),
                                                        value: option.value
                                                    }))}
                                                />
                                            </td>
                                            <td style={{ width: '180px' }}>
                                                <CommonInput
                                                    type={INPUT_TYPES.text}
                                                    value={Lang(button.text, currentLang)}
                                                    onChange={(value: any) => onChange({ ...button, text: setTextByLang(button.text, currentLang, value.target.value) }, index)}
                                                />
                                            </td>
                                            <td>
                                                <CommonInput
                                                    type={INPUT_TYPES.text}
                                                    value={Lang(button.textMobile, currentLang)}
                                                    onChange={(value: any) => onChange({ ...button, textMobile: setTextByLang(button.textMobile, currentLang, value.target.value) }, index)}
                                                />
                                            </td>
                                            <>
                                                <td>
                                                    {button.type?.includes('anchor') ? (
                                                        <>
                                                            {hasAnchors ? (
                                                                <CommonInput
                                                                    type={INPUT_TYPES.dropdown}
                                                                    value={button.anchor}
                                                                    onChange={(value: any) => onChange({ ...button, anchor: value }, index)}
                                                                    options={anchorTypes}
                                                                />
                                                            ) : (
                                                                <ActionsButton>{t('teams.adminPage.additionalFields.anchor_not_exist')}</ActionsButton>
                                                            )}
                                                        </>
                                                    ) : (
                                                        <>
                                                            {!!button?.isRequired ? (
                                                                <ActionsButton>{t(`teams.adminPage.additionalFields.button_${button.actionType}`)}</ActionsButton>
                                                            ) : (
                                                                <SpecialDropdownButtons
                                                                    currentLang={currentLang}
                                                                    button={button}
                                                                    index={index}
                                                                    onChange={onChange}
                                                                    actualForms={forms}
                                                                />
                                                            )}
                                                        </>
                                                    )}
                                                </td>

                                                <td>
                                                    {!!button?.isRequired ? (
                                                        <FlexBox justify={'flex-start'}>

                                                        </FlexBox>
                                                    ) : (
                                                        <DefaultButton wh={131} whMob={107} onClick={() => OnDelete(index)}>{t('teams.adminPage.buttons.delete')}</DefaultButton>
                                                    )}
                                                </td>
                                            </>
                                        </tr>
                                    );
                                })}
                            </TBody>
                        </JustTable>
                    )}
                </>
            )}
        </>
    )
}

export default ButtonEditGroup;